import gql from 'graphql-tag';

export const deleteVisitorWatchlist = gql(`
  mutation deleteVisitorWatchlist(
    $visitorWatchlistId: String!
    $organizationId: String!
  ) {
    deleteVisitorWatchlist(
      visitorWatchlistId: $visitorWatchlistId
      organizationId: $organizationId
    )
  }
`);
